<script>
import { mapActions } from 'vuex'
import CustomStore from 'devextreme/data/custom_store'
import { setFocus } from '@/services/crud'

export default {
  props: {
    field: {},
    label: {},
    width: {},
    model: {
      type: Object,
      default: () => ({})
    },
    component: {
      type: String,
      required: true
    },
    autocomplete: {
      type: Function,
      required: true
    }
  },
  watch: {
    async model () {
      this.defineModel()
    }
  },
  async created () {
    this.modal = await this.newModal({
      component: this.component,
      width: this.width,
      onSave: (data) => {
        this.$emit('change', data)
        this.selecionado = true
      }
    })
    this.defineModel()
  },
  data () {
    return {
      escrito: '',
      selecionado: false,
      modal: false,
      dataSource: {
        store: new CustomStore({ load: this.busca, byKey: this.byKey }),
        paginate: true,
        pageSize: 10
      }
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open'
    }),
    clean () {
      this.escrito = ''
    },
    fieldFocus () {
      setFocus('input', this.$refs.field.$el)
    },
    busca (parametros) {
      if (typeof parametros.searchValue !== 'undefined') {
        let searchValue = parametros.searchValue
        let qtd = parametros.take
        let page = (parametros.skip / qtd) + 1
        return this.autocomplete({ searchValue, qtd, page })
      }
    },
    byKey (key) {
      if (key) return this.busca({ searchValue: key, take: 10, skip: 0 })
      else return []
    },
    limpaField (e) {
      if (e.element.querySelector('input').value === '') this.$emit('change', {})
    },
    mudaOpcao ({ selectedItem }) {
      if (typeof selectedItem === 'object' && selectedItem && selectedItem[this.field]) this.$emit('change', selectedItem)
    },
    setValueOpen () {
      this.escrito = this.$refs.field.instance.element().querySelector('input').value
      return this.abrir()
    },
    abrir () {
      this.openModal({
        modal: this.modal,
        data: this.escrito
      })
    },
    async defineModel () {
      if (this.model && this.model[this.field]) {
        this.escrito = this.model[this.field]
      } else this.escrito = ''
      // Seleciona
      if (this.selecionado) {
        this.fieldFocus()
        this.selecionado = false
      }
    }
  }
}
</script>

<template>
  <div class="field-busca">
    <div class="label">{{ label }}:</div>
    <dx-select-box
      ref="field"
      :data-source="dataSource"
      :show-clear-button="true"
      item-template="searchTemplate"
      :value.sync="escrito"
      :value-expr="field"
      :display-expr="field"
      :search-enabled="true"
      :onInput="limpaField"
      :onSelectionChanged="mudaOpcao">
      <div slot="searchTemplate" slot-scope="data">
        <span>{{ data[field] }}</span>
      </div>
    </dx-select-box>
    <dx-button icon="find" @click="setValueOpen()" />
  </div>
</template>
